const EUROS = 'EUR';
const XPF = 'XPF';

/**
 * Formate la valeur en chaine adaptée.
 */
export const formatMontant = (
  value: number,
  precision: number = 2,
  devise: boolean = false,
  currency: 'EUR' | 'XPF' = EUROS,
  percent: boolean = null,
): string => {
  let options = {};

  if (percent) {
    options = {
      style: 'percent',
      maximumFractionDigits: precision,
    };
  } else if (devise) {
    if (currency === EUROS) {
      options = {
        style: 'currency',
        currency: EUROS,
        maximumFractionDigits: precision,
        minimumFractionDigits: precision,
      };
    } else {
      options = {
        style: 'currency',
        currency: XPF,
      };
    }
  } else {
    options = {
      style: 'decimal',
      maximumFractionDigits: precision,
      minimumFractionDigits: precision,
    };
  }

  const formatedValue = new Intl.NumberFormat('fr-FR', {
    ...options,
  }).format(percent ? value / 100 : value);

  return formatedValue;
};

export default formatMontant;
